import { TestimonialSectionProps } from '../../types/components/pricing/TestimonialSection';

import Testimonial from './Testimonial';

const TestimonialSection: React.FC<TestimonialSectionProps> = ({
  pageContent,
}) => {
  if (!pageContent?.testimonial?.length) return;

  const testimonial = pageContent.testimonial[0];

  return (
    <section className="pt-5 md:pt-20" cy-test-id="testimonial-section">
      <div className="flex flex-col items-center justify-center w-full">
        <Testimonial
          quote={testimonial.testimonial_text}
          author={testimonial.customer_name}
          authorTitle={testimonial.customer_title}
        />
      </div>
    </section>
  );
}

export default TestimonialSection;
